import React from 'react'

import ProfileMenu from './ProfileMenu'

const Header = () => {
  return (
    <header className="hidden w-full lg:flex">
      <div className="ml-auto">
        <div className="flex">
          {/**@TODO Notification component will come here */}
          <ProfileMenu />
        </div>
      </div>
    </header>
  )
}

export default Header
